module.exports = "/images/link-file.svg?f31254c3228bde48b3c7abfb84550a13";